import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskQueuesViewsConfigRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-views-config',
	path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit/:boardId',
	query: ['config?'],
	exact: true,
};
